import { render } from "./HelloWorld.vue?vue&type=template&id=182ce3a2&scoped=true&ts=true"
import script from "./HelloWorld.vue?vue&type=script&lang=ts"
export * from "./HelloWorld.vue?vue&type=script&lang=ts"

import "./HelloWorld.vue?vue&type=style&index=0&id=182ce3a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-182ce3a2"]])

export default __exports__